import { z } from 'zod';

export const CalibrationDoneSchema = z.object({
  result: z.number(),
});

export type CalibrationDone = z.infer<typeof CalibrationDoneSchema>;
